"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowLeft01Icon } from "@hugeicons-pro/core-stroke-rounded";
import type { ComponentProps, FC } from "react";
import { cn } from "../../utils";
import { Button } from "../button";
import useSlider from "./hooks/useSlider";
import {
  arrowOffset,
  sliderArrowIconVariants,
  sliderArrowVariants,
} from "./variants";

type Props = ComponentProps<typeof Button> & {
  placement?: "outside" | "edge";
  iconClassName?: string;
};

const SliderPrevious: FC<Props> = ({
  className,
  iconClassName,
  children,
  placement = "outside",
  variant = "outline",
  size = "icon-sm",
  ...props
}) => {
  const { scrollPrev, canScrollPrev, dir } = useSlider();

  return (
    <Button
      data-slot="slider-previous"
      variant={variant}
      size={size}
      className={cn(
        sliderArrowVariants({ placement }),
        arrowOffset(placement, "previous", dir),
        className,
      )}
      disabled={!canScrollPrev}
      onClick={scrollPrev}
      {...props}
    >
      {children ?? (
        <HugeiconsIcon
          icon={ArrowLeft01Icon}
          className={cn(sliderArrowIconVariants({ placement }), iconClassName)}
        />
      )}
      <span className="sr-only">Previous slide</span>
    </Button>
  );
};

export default SliderPrevious;
